// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, new-cap, babel/new-cap, react-hooks/exhaustive-deps */
import * as React from "react"
import { useDispatch } from "react-redux"
import { CookiesProvider } from "@kiwicom/cookies"
import OrbitProvider from "@kiwicom/orbit-components/lib/OrbitProvider"
import { ThemeProvider } from "styled-components" // eslint-disable-line no-restricted-imports
import * as R from "ramda"
import { getBrandTheme } from "@kiwicom/nitro/lib/records/Theme"
import { Provider as BrandProvider } from "@kiwicom/nitro/lib/services/brand/context"
import { brandDefault } from "@kiwicom/nitro/lib/records/Brand"
import type { Brand } from "@kiwicom/nitro/lib/records/Brand"
import type { Session } from "@kiwicom/nitro/lib/records/Session"
import type { IntlRaw } from "@kiwicom/nitro/lib/records/Intl"
import { AuthProvider } from "@kiwicom/nitro/lib/services/auth/context"
import { LogProvider } from "@kiwicom/nitro/lib/services/log/context"
import { Endpoint } from "@kiwicom/nitro/lib/services/auth/api"

import SyncStore from "./components/SyncStore"
import NitroBridge from "../NitroBridge"
import getFontFamilyFromLanguageAndBrand from "../../utils/getFontFamilyFromLanguageAndBrand"
import { logout } from "../../consts/nitroActions"
import { useFeature } from "@kiwicom/darwin"

type Props = {
  brand: Brand
  intl: IntlRaw
  session: Session
  children: React.ReactNode
  onLogout?: () => void
  endpoint: Endpoint
}

// TODO
// Hotfix, remove ASAP
const TMP_kiwiFallback = R.over(
  R.lensPath(["theme", "palette"]),
  R.defaultTo(brandDefault.theme.palette),
)

const NitroProvider = ({ brand, intl, session, children, onLogout, endpoint }: Props) => {
  // This logic about the font family is already encapsulated in the getBrandTheme from Nitro in later
  // versions, but we need it here for now since we don't have the new version yet.
  const tmpTokens = getBrandTheme(TMP_kiwiFallback(brand), intl.language.direction === "rtl")
  const isSkyUsersV2Enabled = useFeature("USE_SKYUSERS_V2")
  const tokens = {
    ...tmpTokens,
    orbit: {
      ...tmpTokens.orbit,
      fontFamily: getFontFamilyFromLanguageAndBrand({
        language: intl.language,
        brandDomain: brand.domain,
      }),
    },
  } as const
  const dispatch = useDispatch()
  // @ts-expect-error: Flow to TS migration.
  const onSignOut = React.useCallback(() => {
    // Yes, we have to dispatch it the next loop as auth redux state has to be updated first
    setTimeout(() => {
      dispatch(logout())
      if (onLogout) {
        onLogout()
      }
    })
  })

  return (
    <CookiesProvider>
      <NitroBridge intl={intl} session={session}>
        <ThemeProvider theme={tokens}>
          <OrbitProvider theme={tokens}>
            <BrandProvider value={brand}>
              <AuthProvider
                isSkyUsersV2Enabled={isSkyUsersV2Enabled}
                langInfo={intl.language}
                brand={brand}
                onSignOut={onSignOut}
                endpoint={endpoint}
              >
                {/* @ts-expect-error: Flow to TS migration. */}
                <LogProvider>
                  <SyncStore />
                  {children}
                </LogProvider>
              </AuthProvider>
            </BrandProvider>
          </OrbitProvider>
        </ThemeProvider>
      </NitroBridge>
    </CookiesProvider>
  )
}

export default NitroProvider
